import { Path } from "react-native-svg";

import { type FixedIconProps, Icon } from "../../../../../../../../mads/icons/Icon";

export function WorkSettingIcon(props: Readonly<FixedIconProps>): React.JSX.Element {
  return (
    <Icon {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 3C3.22386 3 3 3.22386 3 3.5V16.5C3 16.7761 3.22386 17 3.5 17H5V12H9V17H16.5C16.7761 17 17 16.7761 17 16.5V9.5C17 9.22386 16.7761 9 16.5 9H12V3.5C12 3.22386 11.7761 3 11.5 3H3.5ZM5 8H10V9H5V8ZM10 5H5V6H10V5Z"
        fill="#767676"
      />
    </Icon>
  );
}
